import config from 'constants/config'
import loadScript from 'lib/window/loadScript'

let geocoder: google.maps.Geocoder
let apiPromise: Promise<void> | undefined
let isAPILoaded = false

const scriptPromise = () => {
  if (!config.GOOGLE_MAPS_API_KEY) {
    return Promise.reject('Google maps api key not setup')
  }

  if (apiPromise) {
    return apiPromise
  }

  if (!isAPILoaded) {
    apiPromise = loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAPS_API_KEY}&libraries=places&language=en-AU`,
    ).then(() => {
      isAPILoaded = true
      apiPromise = undefined
      geocoder = new window.google.maps.Geocoder()
    })

    return apiPromise
  }

  return Promise.resolve()
}

export interface GeoDetails {
  place_id: string;
  google_result: {
    continent: string;
    country: string;
    administrative_area_level_1: string;
    locality: string;
    colloquial_area: string;
  }
  location_alert: {
    level: string;
    value: string;
    geocode: {
      lng: number;
      lat: number;
    }
  }
}

export function getGoogleGeocode(request: google.maps.GeocoderRequest, localityLevel?: 'country' | 'administrative_area_level_1' | 'locality' | 'colloquial_area') {
  return scriptPromise().then(() => new Promise<GeoDetails>((resolve, reject) => {
    geocoder.geocode(request, (places, status) => {
      if (status !== window.google.maps.GeocoderStatus.OK) {
        return reject(status)
      }
      if (!places) {
        return reject('no places found')
      }

      const localityPlace = (localityLevel ? places.find(place => place.types.includes(localityLevel)) : places[0]) ?? places[0]
      const address = localityPlace.address_components
      const place_id = localityPlace.place_id

      const getRegionLevelValue = (regionLevel) => address.find(item => item.types[0] === regionLevel)?.long_name || ''
      const geoDetails = {
        place_id,
        google_result: {
          continent: '',
          country: getRegionLevelValue('country'),
          administrative_area_level_1: getRegionLevelValue('administrative_area_level_1'),
          locality: getRegionLevelValue('locality'),
          colloquial_area: getRegionLevelValue('colloquial_area'),
        },
        location_alert: {
          level: address[0].types[0],
          value: address[0].long_name,
          geocode: {
            lng: localityPlace.geometry.location.toJSON().lng,
            lat: localityPlace.geometry.location.toJSON().lat,
          },
        },
      }

      resolve(geoDetails)
    })
  }),
  )
}
